import { setContext } from 'apollo-link-context';

// Implemented based on recommended way of handling authentication headers.
// https://www.apollographql.com/docs/react/recipes/authentication.html#Header
export default sessionHeaders =>
  setContext((_, { headers }) => ({
    headers: {
      ...headers,
      ...sessionHeaders,
    },
  }));
